import {
  CommandInfo,
  SendToDivisionCommandInfo,
  SendToLanesCommandInfo,
  SendToNodeGroupsCommandInfo,
  SendToSiteNumbersCommandInfo,
} from '../../Interfaces/Commands/CommandInfo';

export const getCommandInfo = (category: string) => {
  let commandInfo: CommandInfo = {
    Command: 'ResetDevice',
    Parameters: `<DeviceName>${category}</DeviceName>`,
  };
  return commandInfo;
};

export const getSendToSiteNumbersCommandInfo = (
  commandInfo: SendToSiteNumbersCommandInfo
) => {
  let sendToSiteNumbersCommandInfo: SendToSiteNumbersCommandInfo = {
    Division: commandInfo.Division,
    SiteNumbers: commandInfo.SiteNumbers,
    CommandInfo: {
      Command: commandInfo.CommandInfo.Command,
      Parameters: `<ImportRecords><FilePath>${commandInfo.CommandInfo.Parameters}</FilePath></ImportRecords>`,
    },
  };
  return sendToSiteNumbersCommandInfo;
};

export const getSendToNodeGroupsCommandInfo = (
  commandInfo: SendToNodeGroupsCommandInfo
) => {
  let sendToSiteNumbersCommandInfo: SendToNodeGroupsCommandInfo = {
    Division: commandInfo.Division,
    SiteNumber: commandInfo.SiteNumber,
    NodeGroups: commandInfo.NodeGroups,
    CommandInfo: {
      Command: commandInfo.CommandInfo.Command,
      Parameters: `<ImportRecords><FilePath>${commandInfo.CommandInfo.Parameters}</FilePath></ImportRecords>`,
    },
  };
  return sendToSiteNumbersCommandInfo;
};

export const getSendToLanesCommandInfo = (
  commandInfo: SendToLanesCommandInfo
) => {
  let sendToSiteNumbersCommandInfo: SendToLanesCommandInfo = {
    Division: commandInfo.Division,
    SiteNumber: commandInfo.SiteNumber,
    NodeGroup: commandInfo.NodeGroup,
    LaneNumbers: commandInfo.LaneNumbers,
    CommandInfo: {
      Command: commandInfo.CommandInfo.Command,
      Parameters: `<ImportRecords><FilePath>${commandInfo.CommandInfo.Parameters}</FilePath></ImportRecords>`,
    },
  };
  return sendToSiteNumbersCommandInfo;
};

export const getSendToDivisionCommandInfo = (
  commandInfo: SendToDivisionCommandInfo
) => {
  let sendToSiteNumbersCommandInfo: SendToDivisionCommandInfo = {
    Divisions: commandInfo.Divisions,
    CommandInfo: {
      Command: commandInfo.CommandInfo.Command,
      Parameters: `<ImportRecords><FilePath>${commandInfo.CommandInfo.Parameters}</FilePath></ImportRecords>`,
    },
  };
  return sendToSiteNumbersCommandInfo;
};
